import { jsx as l } from "react/jsx-runtime";
import a from "clsx";
import { Children as y } from "react";
import '../../assets/content.css';const g = "_content_15ey0_2", n = {
  content: g,
  "content--align-center": "_content--align-center_15ey0_439",
  "content--color-inherit": "_content--color-inherit_15ey0_443",
  "content--color-light": "_content--color-light_15ey0_447",
  "content--color-dark": "_content--color-dark_15ey0_451",
  "content--color-success": "_content--color-success_15ey0_455",
  "content--color-warning": "_content--color-warning_15ey0_459",
  "content--color-error": "_content--color-error_15ey0_463",
  "content--color-info": "_content--color-info_15ey0_467",
  "content--table-scroll": "_content--table-scroll_15ey0_535"
}, m = ({
  children: o,
  align: i,
  color: t,
  __html: e,
  tableScroll: s,
  className: _ = "",
  ...c
}) => {
  const r = a(
    {
      [n.content]: !0,
      [n["content--align-center"]]: i === "center",
      [n["content--color-inherit"]]: t === "inherit",
      [n["content--color-success"]]: t === "success",
      [n["content--color-error"]]: t === "error",
      [n["content--color-warning"]]: t === "warning",
      [n["content--color-info"]]: t === "info",
      [n["content--color-light"]]: t === "light",
      [n["content--color-dark"]]: t === "dark",
      [n["content--table-scroll"]]: s
    },
    _
  );
  return e ? /* @__PURE__ */ l(
    "div",
    {
      className: r,
      dangerouslySetInnerHTML: { __html: e },
      ...c
    }
  ) : y.count(o) ? /* @__PURE__ */ l("div", { className: r, ...c, children: o }) : null;
};
export {
  m as Content
};
